import * as React from 'react';
import { EditModeAction, EditorActionsManager, VirtualRootComponent } from '@easytwin/runtime';
import { Divider } from '@arco-design/web-react';
import { observer } from 'mobx-react-lite';
import { ProButton } from '@/UIGenerator';
import { ComponentBasePanel } from './ComponentBasePanel';

interface VirtualRootStatePanelProps {
  comp: VirtualRootComponent;
  /** 默认取comp.name */
  title?: string;
}

export const VirtualRootStatePanel: React.FC<React.PropsWithChildren<VirtualRootStatePanelProps>> =
  observer((props) => {
    const { title, comp, children } = props;
    const editorActionMgr = comp.engine.getManager(EditorActionsManager);

    return (
      <ComponentBasePanel comp={comp}>
        <div className='my-4 flex items-center mx-3'>
          {comp.isEditing ? (
            <ProButton
              long
              size='small'
              type='primary'
              onClick={() => {
                editorActionMgr.execute(new EditModeAction(comp, false));
              }}
            >
              结束新增
            </ProButton>
          ) : (
            <ProButton
              long
              size='small'
              onClick={() => {
                editorActionMgr.execute(new EditModeAction(comp, true));
              }}
            >
              新增子要素
            </ProButton>
          )}
        </div>
        <Divider className='!my-0' />
        {children}
      </ComponentBasePanel>
    );
  });
